// extracted by mini-css-extract-plugin
export var card = "_8i-0";
export var failedIcon = "_8i-4";
export var failedIconBadge = "_8i-3";
export var icon = "_8i-1";
export var successIcon = "_8i-2";